import Emitter from "tiny-emitter";

const eventHub = new Emitter();
eventHub.trigger = eventHub.emit;
export default eventHub;
